/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from "vue-svgicon";
icon.register({
  trash: {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    data:
      '<path d="M 10 1.9667969 C 9.817 1.9667969 9.6344687 2.025125 9.4804688 2.140625 L 5.6679688 5 L 17.667969 5 L 15.384766 3.2871094 C 15.145766 3.1081094 14.831734 3.0658281 14.552734 3.1738281 L 12.802734 3.8515625 L 10.519531 2.140625 C 10.365531 2.025125 10.183 1.9667969 10 1.9667969 z M 4.6777344 7 C 4.3097344 7 4.0262187 7.3244531 4.0742188 7.6894531 L 5.75 20.263672 C 5.883 21.257672 6.7304219 22 7.7324219 22 L 15.982422 22 C 16.985422 22 17.831844 21.257672 17.964844 20.263672 L 19.642578 7.6894531 C 19.690578 7.3244531 19.405109 7 19.037109 7 L 4.6777344 7 z"/>',
  },
});
